import React from 'react';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import DialogActions from '@material-ui/core/DialogActions';
import { requestResponse } from '../Requests';
import { useHistory } from 'react-router';
import { pathname } from '../../../../utils';
import LoadingButton from '../../../lowLevel/LoadingButton';

const useStyles = makeStyles((theme: any) => ({
  logo: { width: 70, marginBottom: '10px', marginTop: '40px' },
  topMargin: {
    marginTop: theme.spacing(2),
    fontWeight: 'bold',
  },
  bottomMargin: {
    marginBottom: theme.spacing(2),
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  button: {
    fontSize: 'large',
    minWidth: 175,
  },
}));

export default function CustomerRejected({ showResponse, loading }) {
  const classes = useStyles();
  const history = useHistory();

  const onClick = async () => {
    await showResponse(requestResponse.complete);
  };
  const redirectToPayments = async () => {
    await onClick();
    history.push(pathname.remittance.url);
  };
  return (
    <>
      <DialogContent className={classes.root}>
        <img
          src={'./icons/edit.svg'}
          className={classes.logo}
          alt="edit logo"
        />
        <Typography variant="h5" className={classes.topMargin}>
          You're request change was not applied.
        </Typography>
        <Typography variant="h6">
          Your funds delivery schedule has not been changed.
        </Typography>
        <Typography variant="h6" className={classes.bottomMargin}>
          You do not need to take any further action.
        </Typography>
        <DialogActions>
          <LoadingButton
            variant="contained"
            className={classes.button}
            color="primary"
            onClick={onClick}
            loading={loading}
          >
            <b>Thanks</b>
          </LoadingButton>
        </DialogActions>
        <DialogActions>
          <Button className={classes.button} onClick={redirectToPayments}>
            <b>I need to request a different change.</b>
          </Button>
        </DialogActions>
      </DialogContent>
    </>
  );
}
